var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 8,
    fill: "#6FCF97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3365 8.65398L11.274 14.8538L8.4955 12.0122C8.07704 11.5843 7.39845 11.5842 6.97991 12.0121C6.56138 12.4401 6.56138 13.134 6.97991 13.5621L10.5162 17.1786C10.7172 17.3842 10.9898 17.4997 11.274 17.4997C11.5582 17.4997 11.8308 17.3842 12.0318 17.1787L15.442 13.6913L18.8521 10.204C19.2706 9.77597 19.2706 9.08207 18.8521 8.65406C18.4336 8.22604 17.7551 8.22597 17.3365 8.65398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCheckBox);
export default __webpack_public_path__ + "static/media/CheckedCheckBox.d41944854ba48a1769d9e7683dc0f4ea.svg";
export { ForwardRef as ReactComponent };